<template>
	<div class="security_info">
		<div v-if="!this.mobile" class="information_back">
			{{ $store.state.auth.member_info.user_name + $t('merchant.info1') }}
			<span>{{ $t('merchant.info2') }} 0</span> {{ $t('merchant.info3') }}
		</div>

		<div v-else class="box base mb_20">
			<span class="icon_box SECURITY"></span>
			<p class="security_level">
				{{ $store.state.auth.member_info.user_name + $t('merchant.info1') }}
				<span
					>{{ $store.state.auth.member_info.security_level }}
					{{ $t('merchant.info2') }}</span
				>{{ $t('merchant.info3') }}
			</p>
		</div>
	</div>
</template>

<script>
import { isMobile } from '@/common/mobile';
export default {
	name: 'SecurityInfo',
	data() {
		return {
			mobile: isMobile(),
		};
	},
};
</script>
